module.exports = __webpack_public_path__ + "img/iocn9.98f5211d.png";